<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";

.community-form {
    .left-block {
        h2 {
            font-size: 36px;
            letter-spacing: 0.88px;
            line-height: 52px;
        }

        @media screen and (min-width: $screen-md) {
            h2 {
                font-size: 48px;
                letter-spacing: 1.17px;
                line-height: 1.25;
            }
        }

        @media screen and (min-width: $screen-xl) {
            min-height: 600px;
        }
    }

    .right-block {
        box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.03);
        border-radius: 2px;
        background-color: #ffffff;

        ul {
            padding-left: 20px;

            li {
                margin-bottom: 24px;
                font-size: 14px;
                line-height: 1.5;

                @media screen and (min-width: $screen-md) {
                    font-size: 1rem;
                    font-weight: 600;
                }
            }
        }
    }

    .form {
        display: none;
    }
}
</style>

<template>
    <div id="community-form" class="community-form mb-80 mb-md-120 mb-xl-160">
        <div class="container">
            <div class="row no-gutters">
                <div class="col-12 col-lg-6">
                    <div class="left-block d-flex flex-column align-items-start align-items-md-center justify-content-center bg-primary text-md-center p-32 p-md-56 p-xl-80">
                        <h2 class="h1 mb-32 text-white">{{ translations.cta.title }}</h2>
                        <p class="mb-32 w-100 text-white font-weight-light large">{{ translations.cta.content }}</p>
                        <a :href="route('nl.customerPortal')" class="btn btn-white btn-lg btn-special"><span>{{ translations.cta.button }}</span></a>
                    </div>
                </div>
                <div class="col-12 col-lg-6 align-self-center px-sm-32 px-md-0">
                    <div class="right-block bg-white p-32 p-md-64 pr-xl-120">
                        <h2 class="mb-32">{{ translations.advantages.title }}</h2>
                        <ul class="mb-32">
                            <li v-for="(item, index) in translations.advantages.list" :key="index">{{ item.content }}</li>
                        </ul>
                        <a class="read-more" href="">{{ translations.advantages.button }}</a>
                    </div>
                </div>
            </div>
            <div class="form" :class="{'processing': processing}">
                <ValidationObserver v-slot="obs" ref="observer" tag="form" @submit.prevent="submit()">
                    <div class="row">
                        <div class="col-12 col-lg-7">
                            <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props" :name="translations.email" :slim="true">
                                <div class="form-group position-relative mb-lg-0" :class="props.classes">
                                    <input type="text" id="email" class="form-control" :placeholder="translations.email" v-model="formData.email" />
                                    <span class="error">{{ props.errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-12 col-lg-5">
                            <button :disabled="obs.invalid" class="btn btn-lg btn-secondary btn-special w-100"><span>{{ translations.submit }}</span></button>
                        </div>
                    </div>
                </ValidationObserver>

                <div class="spinner-background">
                    <div class="spinner">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formBase from '@mixins/formBase';

export default {
    mixins: [formBase],

    data() {
        return {
            formData: {
                email: "",
            }
        }
    },
}
</script>